import DeleteDialog from 'shell/components/shared/delete-dialog';
import { Fragment, useState, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import TableCard from 'civil-status/components/document-serie/table';
import { DocumentSerieListCrumbs } from 'civil-status/constants/document-serie-breadcrumb';
import ListHeader from 'shell/components/shared/list-header';
import { generatePath, useNavigate } from 'react-router-dom';
import { DocumentSerieItemVM } from 'civil-status/view-models/document-serie-list';
import { HttpResponseList } from 'shell/models/http-response';
import { DocumentSerie } from 'shell/models/document-serie';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { authsRowDocumentSerie } from 'civil-status/components/document-serie/table/table-row';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';

const DocumentSerieList = (): React.ReactElement => {
  const [elementToDelete, setElementToDelete] = useState<null | DocumentSerieItemVM>(null);
  const navigate = useNavigate();

  const [series, getSeries] = useHttpFetch<
    HttpResponseList<DocumentSerie>,
    Array<DocumentSerieItemVM>
  >(`${__CIVIL_STATUS_API_URL__}/serie-atto`, {
    onBootstrap: true,
    options: {
      method: 'GET',
    },
    transformer: (response) =>
      (response?.data?.payload?.list || []).map((item) => ({
        code: item.key?.codiceSerie || '',
        number: item.key?.codiceSerie || '',
        description: item.serie || '',
      })),
  });

  const seriesData = (series.data as Array<DocumentSerieItemVM>) || [];

  const deleteItem = useHttpClient(`${__CIVIL_STATUS_API_URL__}/serie-atto/cancella-serie-atto`, {
    options: {
      method: 'DELETE',
    },
  });

  const clearToDelete = useCallback(() => setElementToDelete(null), [setElementToDelete]);

  const onConfirm = useCallback((): void => {
    if (elementToDelete) {
      (deleteItem({ url: `/${elementToDelete.code}` }) as ResponsePromise<void>).then(() => {
        getSeries();
        setElementToDelete(null);
      });
    }
  }, [elementToDelete, deleteItem, getSeries, setElementToDelete]);

  const auths = useActionAuthorization(authsRowDocumentSerie);

  return (
    <Fragment>
      <Breadcrumbs items={DocumentSerieListCrumbs} />
      <ListHeader
        addBtnAriaLabel="Aggiungi nuova serie"
        addBtnLabel="Aggiungi nuova serie"
        canAdd={auths.add}
        onAddBtnClick={() => {
          navigate('/stato-civile/serie/nuovo');
        }}
        title="Lista Serie Atti"
      />
      <div className="pmi-mt-2">
        <TableCard
          items={seriesData}
          onTrashPress={(card) => setElementToDelete(card)}
          onEditPress={(item) =>
            navigate(generatePath(`/stato-civile/serie/modifica/:id`, { id: item.number }))
          }
          onVisibilityPress={(item) =>
            navigate(generatePath(`/stato-civile/serie/dettaglio/:id`, { id: item.number }))
          }
        />
      </div>
      {Boolean(elementToDelete) ? (
        <DeleteDialog
          isOpen={Boolean(elementToDelete)}
          onAbort={clearToDelete}
          onClose={clearToDelete}
          onConfirm={onConfirm}
        />
      ) : null}
    </Fragment>
  );
};

DocumentSerieList.displayName = 'Document serie list page component';

export default DocumentSerieList;
